<div class="modal-header">
  <h5 class="modal-title">Claim Reward</h5>
  <button type="button" class="close" (click)="onClose()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div *ngIf="loadingData" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <p class="mt-2">Loading data...</p>
  </div>

  <form [formGroup]="form" *ngIf="!loadingData">
    <!-- Username Field - Using searchable dropdown -->
    <div class="row col-12 mb-4">
    <label class="col-4 kt-form__label col-form-label">
      Username <span class="text-danger">*</span>
    </label>

    <div class="col-8 kt-form__control">
      <kt-member-dropdown
        class="col-12 pl-0 p-0 dropdown-maxheight"
        [form]="form"
        [formName]="'username'"
        [selectionAttributes]="'id'"
        [dropdownSettings]="dropdownSettings"
        (selectedItemsChanged)="onSelectedMemberChanged($event)"
        [ngClass]="{'is-invalid': checkValidation && form.controls.username.errors }">
      </kt-member-dropdown>
    </div>
  </div>

    <!-- Reward Field - Using searchable dropdown -->
    <div class="row col-12 mb-4">
      <label class="col-4 kt-form__label col-form-label">
        Reward <span class="text-danger">*</span>
      </label>
      <div class="col-8 kt-form__control">
        <div *ngIf="rewardsLoading" class="text-center py-2">
          <span class="spinner-border spinner-border-sm text-primary mr-2"></span>
          Loading rewards...
        </div>
        <div *ngIf="!selectedMember && !rewardsLoading" class="alert alert-info mb-0">
          <i class="fas fa-info-circle"></i> Please select a member first
        </div>
        <div *ngIf="selectedMember && !rewardsLoading && rewardsDropdown.length > 0" class="position-relative">
          <kt-dropdown-wo-lazyload
            [form]="form"
            [dropdownList]="rewardsDropdown"
            [dropdownSettings]="rewardsDropdownSettings"
            [formName]="'reward'"
            [selectionAttributes]="'id'"
            (selectedItemsChanged)="onSelectedRewardChanged($event)"
            [ngClass]="{'is-invalid': checkValidation && form.controls.reward.errors }">
          </kt-dropdown-wo-lazyload>
        </div>
        <div *ngIf="!rewardsLoading && selectedMember && rewardsDropdown.length === 0" class="alert alert-warning mb-0 mt-2">
          <i class="fas fa-exclamation-triangle"></i> No active rewards available for this member
        </div>
      </div>
    </div>

    <!-- Transfer From - Only show for Free Spin and Deposit rewards -->
    <div class="row col-12 mb-4" *ngIf="showTransferFrom()">
      <label class="col-4 kt-form__label col-form-label">
        Transfer From
      </label>
      <div class="col-8 kt-form__control">
        <div *ngIf="isLoadingWallets" class="text-center py-2">
          <span class="spinner-border spinner-border-sm text-primary mr-2"></span>
          Loading wallets...
        </div>
        <div *ngIf="!isLoadingWallets && providerList.length > 0" class="position-relative">
          <kt-dropdown-wo-lazyload
            [form]="form"
            [dropdownList]="filteredTransferFromList"
            [dropdownSettings]="providerDropdownSettings"
            [formName]="'transfer_from'"
            [selectedItems]="selectedTransferFrom ? [selectedTransferFrom] : []"
            [selectionAttributes]="'id'"
            (selectedItemsChanged)="onSelectedTransferFromChanged($event)"
            [ngClass]="{'is-invalid': checkValidation && form.controls.transfer_from?.errors }">
          </kt-dropdown-wo-lazyload>
        </div>
        <div *ngIf="!isLoadingWallets && providerList.length === 0" class="alert alert-warning mb-0">
          <i class="fas fa-exclamation-triangle"></i> No wallets available
        </div>
      </div>
    </div>

    <!-- Transfer To - Game Provider for this promotion -->
    <div class="row col-12 mb-4" *ngIf="showAdditionalFields && selectedReward && [2, 3, 4].includes(selectedReward.promo_type)">
      <label class="col-4 kt-form__label col-form-label">
        Transfer To <span class="text-danger">*</span>
      </label>
      <div class="col-8 kt-form__control">
        <div *ngIf="isLoadingWallets" class="text-center py-2">
          <span class="spinner-border spinner-border-sm text-primary mr-2"></span>
          Loading game providers...
        </div>
        <div *ngIf="!isLoadingWallets && filteredTransferToList.length > 0" class="position-relative">
          <kt-dropdown-wo-lazyload
            [form]="form"
            [dropdownList]="filteredTransferToList"
            [dropdownSettings]="providerDropdownSettings"
            [formName]="'transfer_to'"
            [selectionAttributes]="'id'"
            (selectedItemsChanged)="onSelectedTransferToChanged($event)"
            [ngClass]="{'is-invalid': checkValidation && form.get('transfer_to')?.errors }">
          </kt-dropdown-wo-lazyload>

          <div *ngIf="checkValidation && form.get('transfer_to')?.errors" class="invalid-feedback d-block">
            <span *ngIf="form.get('transfer_to')?.errors?.required">Game provider is required</span>
          </div>
        </div>
        <div *ngIf="!isLoadingWallets && filteredTransferToList.length === 0" class="alert alert-warning mb-0">
          <i class="fas fa-exclamation-triangle"></i> No game providers available for this promotion
        </div>
      </div>
    </div>

    <!-- Transfer Amount - Only show for Free Spin and Deposit rewards -->
    <div class="row col-12 mb-4" *ngIf="showTransferAmount()">
      <label class="col-4 kt-form__label col-form-label">
        Transfer Amount <span class="text-danger">*</span>
      </label>

      <div class="col-8 kt-form__control">
        <input
          type="text"
          class="form-control"
          formControlName="amount"
          inputmode="decimal"
          placeholder="Enter transfer amount"
          (keypress)="allowNumberOnly($event)"
          (input)="formatAmount($event)"
          [ngClass]="{'is-invalid': checkValidation && form.controls.amount?.errors }"
        >

        <div *ngIf="checkValidation && form.controls.amount?.errors" class="invalid-feedback d-block">
          <span *ngIf="form.controls.amount?.errors?.required">
            Transfer amount is required
          </span>

          <span *ngIf="form.controls.amount?.errors?.invalidNumber">
            Amount must be positive (0 allowed for Free Spin)
          </span>

          <span *ngIf="form.controls.amount?.errors?.invalidDecimal">
            Amount can have up to 2 decimal places
          </span>
        </div>
      </div>
    </div>

    <!-- Bonus Amount - Only show for Free Credit and Deposit rewards -->
    <div class="row col-12 mb-4" *ngIf="showBonusAmount()">
      <label class="col-4 kt-form__label col-form-label">
        Bonus Amount
        <ng-container *ngIf="selectedReward">
          <i *ngIf="selectedRewardType === 'deposit'" class="fa fa-info-circle ml-1 text-muted" matTooltip="Deposit promotion: requirement includes transfer amount and bonus amount. Requirement = (transfer + bonus) × multiplier." matTooltipHideDelay="0"></i>
          <i *ngIf="selectedRewardType === 'free_credit'" class="fa fa-info-circle ml-1 text-muted" matTooltip="Free Credit promotion: requirement is based on bonus only. Requirement = bonus × multiplier." matTooltipHideDelay="0"></i>
        </ng-container>
      </label>
      <div class="col-8 kt-form__control">
        <div class="input-group bonus-readonly-group">
          <div class="input-group-prepend">
            <span class="input-group-text">{{ selectedReward?.currency || 'MYR' }}</span>
          </div>
          <input
            type="text"
            class="form-control bonus-readonly-input"
            [value]="getBonusAmount().toFixed(2)"
            disabled
            readonly>
        </div>

        <div class="requirement-text mt-2" *ngIf="selectedReward && selectedRewardType !== 'free_spin'">
          <ng-container *ngIf="selectedRewardType === 'deposit'; else defaultRequirementText">
            {{ getRequirementLabel() }}:
            
            <ng-container *ngIf="includeTransferAmountInRequirement(); else onlyBonus">
              ({{ selectedReward?.currency || 'MYR' }} {{ getTransferAmountValue() | number:'1.2-2' }} + {{ getBonusAmount() | number:'1.2-2' }})
            </ng-container>
            <ng-template #onlyBonus>
              ({{ selectedReward?.currency || 'MYR' }} {{ getBonusAmount() | number:'1.2-2' }})
            </ng-template>
            x {{ getRequirementMultiplier() }}
            = {{ selectedReward?.currency || 'MYR' }} {{ getRequirementTotal() | number:'1.2-2' }}
          </ng-container>
          <ng-template #defaultRequirementText>
            {{ getRequirementLabel() }}:
            
            {{ selectedReward?.currency || 'MYR' }} {{ getRequirementMultiplicand() | number:'1.2-2' }}
            x {{ getRequirementMultiplier() }}
            = {{ selectedReward?.currency || 'MYR' }} {{ getRequirementTotal() | number:'1.2-2' }}
          </ng-template>
        </div>
      </div>
    </div>

  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="onClose()" [disabled]="loading || loadingData">
    <i class="fa fa-ban"></i> Close
  </button>
  <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="!form.valid || loading || loadingData || isLoadingWallets">
    <i [class]="loading ? 'fas fa-circle-notch fa-spin' : 'fa fa-save'"></i> Submit
  </button>
</div>
